import React from "react";
import { EditButton as RaEditButton } from "react-admin";
import { get } from "lodash";
import moment from "moment";

const CASH_FLOW_DAY = 10;

const EditButton = (props) => {
  const day = moment(get(props, "record.day"));
  const today = moment();
  const thisMonth = today.startOf("month");
  const lastMonth = today.subtract(1, "months").startOf("month");
  if (
    day.isAfter(thisMonth) ||
    (today.day() < CASH_FLOW_DAY && day.isAfter(lastMonth))
  ) {
    return <RaEditButton {...props} />;
  }
  return null;
};

export default EditButton;
